import { render, staticRenderFns } from "./ProblemSolving.vue?vue&type=template&id=8255b408&scoped=true&"
import script from "./ProblemSolving.vue?vue&type=script&lang=js&"
export * from "./ProblemSolving.vue?vue&type=script&lang=js&"
import style0 from "./ProblemSolving.vue?vue&type=style&index=0&id=8255b408&lang=scss&scoped=true&"
import style1 from "./ProblemSolving.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8255b408",
  null
  
)

export default component.exports